import React, {
  createContext,
  useCallback,
  useMemo,
  useRef,
  useState
} from "react";
import PropTypes from "prop-types";

const ModalAvisoContext = createContext();

const ModalAvisoProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState(<></>);
  const closeCallbackRef = useRef(() => {});
  const setCloseCallback = useCallback(callback => {
    closeCallbackRef.current = callback;
  }, []);
  const onClosed = useCallback(() => {
    closeCallbackRef.current();
    setIsOpen(false);
  }, [setIsOpen, closeCallbackRef]);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const toggleModal = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  const sharedValues = useMemo(
    () => ({
      isOpen,
      openModal,
      onClosed,
      message,
      setMessage,
      toggleModal,
      setCloseCallback
    }),
    [
      isOpen,
      openModal,
      onClosed,
      message,
      setMessage,
      toggleModal,
      setCloseCallback
    ]
  );
  return (
    <ModalAvisoContext.Provider value={sharedValues}>
      {children}
    </ModalAvisoContext.Provider>
  );
};

ModalAvisoProvider.propTypes = {
  children: PropTypes.node
};

export { ModalAvisoContext, ModalAvisoProvider };
